export const environment = {
  production: true,
  buildId: '3762474703223351',
  configFile: 'config.json',
};
